<div class="card">
  <div class="card-body">
    <div class="row">
      <div class="col-md-12">
        @if (loading) {
          <div class="spinner-container">
            <ngx-spinner name="spinnerAbastecedoras" bdOpacity="0.3" Color="rgba(193,193,193,0)" size="medium" color="#185db5" type="ball-grid-beat" [fullScreen]="false">
              <p style="color: white">{{messageSpinner}}</p>
            </ngx-spinner>
          </div>
        } @else  {
          <div class="row" style="float: right; margin-bottom: 1em; margin-right: 1em;">
            <button class="d-flex btn btn-primary" type="button" [disabled]="loading" (click)="modalGenerarInforme()">Informe de aerovales</button>
          </div>
          <table class="table table-striped table-hover" [formGroup]="tablaAbastecedoras">
            <thead class="text-center">
              <tr>
                <th>Expendedora</th>
                <th>Estado</th>
                <th>Fecha/Hora precierre</th>
              </tr>
            </thead>
            @if(encontroCierres()) {
              <tbody class="text-center">
                @for(exp of hayCierre?.precierres; track $index) {
                  <tr>
                    <td>{{exp.nombreExpendedora}}</td>
                    <td>
                      @if(exp.estadoDeCierre == 1) {
                        Pendiente <button class="btn btn-primary ms-2" (click)="precerrarAbastecedora(exp)">Precerrar abastecedora</button>
                      } @else {
                        Precerrada <button class="btn btn-primary ms-2" (click)="precerrarAbastecedora(exp)">Modificar Precierre</button>
                      }
                    </td>
                    <td>{{exp.fechaHoraPrecierre | date: "d'/'MM'/'y' 'hh:mm a"}}</td>
                  </tr>
                }
              </tbody>
            }
          </table>
          @if(hayCierre?.estadoCierre == EstadoCierre.Abierto && hayRemitoVencidos && mostrarTablaRemitosContado) {
            <div class="alert alert-danger text-center col-7">
              Debe facturar los Remitos de Contado para Realizar el Cierre de Turno.
            </div>
          }
          @if(consultandoSiHayRemitosSF) {
            <loading-text-spinner message="Consultando remitos..." color="primary"></loading-text-spinner>
          }
          @if(mostrarTablaRemitosContado && !loading) {
            <div class="text-start col-10">
              <b class="text-start">Remitos contado sin facturar</b>
            </div>
            <table id="tablaRemitos" class="table table-striped table-hover letra" style="width:60%">
              <thead class="text-center">
                <tr>
                  <th>Remito</th>
                  <th>Fecha</th>
                  <th>Cliente</th>
                  <th>Aerovale</th>
                  <th>Ver</th>
                  <th>Fecha límite a facturar</th>
                </tr>
              </thead>
              <tbody class="text-center">
                @for(rem of remitosContadoSF; let i = $index; track $index) {
                  <tr>
                    <td [ngClass]="{'remarcar': rem.vencido}" style="width: 13%;">{{rem.remitoPrefijo | remitoPrefijo }}-{{rem.remitoNumero | remitoNumero }}</td>
                    <td [ngClass]="{'remarcar': rem.vencido}">{{rem.fechaHoraCreacion | date: "dd'/'MM'/'y' 'hh:mm a"}}</td>
                    <td [ngClass]="{'remarcar': rem.vencido}">{{rem.clienteCtaSGC}} - {{rem.clienteNombre}}</td>
                    <td [ngClass]="{'remarcar': rem.vencido}" style="width: 12%;">{{rem.aerovalePrefijo | aerovalePrefijo }}{{rem.aerovaleNumero | aerovaleNumero}}</td>
                    <td [ngClass]="{'remarcar': rem.vencido}">
                      <button [disabled]="bloquearBotones" type="button" ngbTooltip="Ver Aerovales" (click)="obtenerAerovale(rem.aerovaleId, i)" class="btn">
                        <i class="fa fa-eye" aria-hidden="true"></i>
                      </button>
                      @if(aerovaleSeleccionado == i) {
                        <loading-text-spinner message="Obteniendo aerovale..." color="primary"></loading-text-spinner>
                      }
                    </td>
                    <td [ngClass]="{'remarcar': rem.vencido}">{{rem.fechaLimite | date: "dd'/'MM'/'y' 'hh:mm a"}}</td>
                  </tr>
                }
              </tbody>
            </table>
            <span style="color: red; display: block; font-size: 10pt;">
              *Remitos de Contado sin facturar con más de 48 hrs.
            </span>
          }
          @if(!encontroCierres() && !loading) {
            <div class="modal-body">
              <div class="alert alert-warning">No hay precierres para la aeroplanta seleccionada.</div>
            </div>
          }
        }
      </div>
    </div>
  </div>
  @if (hayCierre != null && ((!loading && !realizandoCierre) || (loading && realizandoCierre) )) {
    <div class="card-footer">
      <div class="float-end">
        <button class="d-flex btn btn-primary" (click)="realizarCierre()" [disabled]="loading || realizandoCierre || cargandoProductos || noContinua || (hayCierre?.estadoCierre == EstadoCierre.Abierto && hayRemitoVencidos)">
          @if(!realizandoCierre) {
            {{hayCierre?.estadoCierre == EstadoCierre.Abierto ? 'Realizar cierre de turno' : 'Continuar cierre de turno'}}
          }
          @if(realizandoCierre) {
            <div class="d-flex align-items-center">
              <div class="spinner-border text-light spinner-border-sm" role="status"></div>
              <span>{{hayCierre?.estadoCierre == EstadoCierre.Abierto ? 'Realizando cierre...' : 'Continuando cierre...'}}</span>
            </div>
          }
        </button>
      </div>
    </div>
  }
</div>
